var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-tabs__active-bar",class:`is-${ _vm.rootTabs.tabPosition }`,style:(_vm.barStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }